export const GOOGLE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLScqXibdY_U0aVsBN7keTPS3IlXpagFHyPPAXk8iU56CPH3Lsg/viewform";

export const MEDIA = {
  hero: "https://images.pexels.com/photos/17201699/pexels-photo-17201699.jpeg",
  portrait: "https://images.pexels.com/photos/20145960/pexels-photo-20145960.jpeg",
  action: "https://images.pexels.com/photos/4720794/pexels-photo-4720794.jpeg",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Method", href: "#method" },
  { label: "Programs", href: "#programs" },
  { label: "Results", href: "#results" },
  { label: "FAQ", href: "#faq" },
];
